import PropTypes from 'prop-types';

export const myTableHeadCellPropTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'actions',
    'number',
    'text',
    'date',
    'dateMonth',
    'currency',
    'avatar',
    'thumbnail',
    'custom',
  ]).isRequired,
  align: PropTypes.oneOf([
    'right', 'left',
  ]),
  padding: PropTypes.bool,
  sorting: PropTypes.bool,
  labelId: PropTypes.string,
  onRender: PropTypes.func,
};

export const defaultMyTableHeadCellPropTypes = {
  align: 'left',
  padding: true,
  sorting: true,
  labelId: undefined,
};
